import { createAction, props } from '@ngrx/store';
import { AccessToken } from '@okta/okta-auth-js';

import {
  FactorVerify,
  SignInFailReason,
  AuthTransaction,
  SignInOptions,
  LoginClient,
  ResetPasswordOptions,
  ResetPasswordFailReason,
} from './login.models';

export const signIn = createAction(
  '[Login] Start Sign-in',
  props<{ options: SignInOptions }>(),
);

export const signInSuccess = createAction('[Login] Sign-in Success');

export const signInFailed = createAction(
  '[Login] Sign-in Failed',
  props<{ reason: SignInFailReason; errorId?: string }>(),
);

export const staySignIn = createAction('[Login] Stay Sign-in');

export const mfaTimeOut = createAction('[Login] MFA Timed out');

export const mfaResendExceedLimit = createAction(
  '[Login] MFA Resend Exceed Limit',
);

export const mfaCodeExceedLimit = createAction('[Login] MFA Code Exceed Limit');

export const updateTransaction = createAction(
  '[Login] Update Transaction',
  props<{ transaction: AuthTransaction }>(),
);

export const sendCodeToFactor = createAction(
  '[Login] Send Code to Factor',
  props<{ factor: FactorVerify; canGoBack: boolean }>(),
);

export const setLockoutLoginRedirectUrl = createAction(
  '[Login] Set Lockout Login RedirectUrl',
  props<{ url: string }>(),
);

export const resendCodeToFactor = createAction('[Login] Resend Code to Factor');

export const verifyFactor = createAction(
  '[Login] Verify Factor',
  props<{ code: string; rememberDevice: boolean }>(),
);

export const exchangeToken = createAction(
  '[Login] Get Token',
  props<{ sessionToken: string }>(),
);

export const enrollEmailFactor = createAction('[Login] Enroll Email Factor');

export const enrollPhoneFactor = createAction(
  '[Login] Enroll Phone Factor',
  props<{ phoneNumber: string }>(),
);

export const onNewRegistration = createAction(
  '[Login] On New Registration',
  props<{ phoneNumber: string }>(),
);

export const activateFactor = createAction(
  '[Login] Activate Factor',
  props<{ code: string }>(),
);
export const clearActivateFactor = createAction(
  '[Login] clearActivateFactor Factor',
);

export const skipEnrollFactor = createAction('[Login] Skip Enroll Factor');

export const goBack = createAction('[Login] Go Back');

export const logout = createAction(
  '[Login] Logout',
  props<{ userAction: 'logout' | 'inactive' }>(),
);

export const impersonatorLogout = createAction('[Login] Impersonator Logout');

export const cancelTransaction = createAction('[Login] Cancel Transaction');

export const prevTransaction = createAction('[Login] Previous Transaction');

export const impersonate = createAction('[Login] Impersonate');

export const federate = createAction('[Login] Federate');

export const stepup = createAction('[Login] Step Up');

export const impersonateSuccess = createAction(
  '[Login] Impersonate Success',
  props<{
    accessToken: AccessToken;
  }>(),
);

export const updateLoginClient = createAction(
  '[Login] Update Login Client',
  props<{ clientId: LoginClient }>(),
);

export const resetState = createAction('Reset State');

export const introspectSuccess = createAction(
  '[Login] Introspect Success',
  props<{ token?: string }>(),
);

export const loginTimeout = createAction('[Login] Login Timeout');

export const acceptNewUserAgreement = createAction(
  '[Login] Accept New User Agreeement',
);
export const updateUserAgreementVersion = createAction(
  '[Login] Update User Agreement Version',
  props<{ version: string }>(),
);

export const scheduleLoadingSpinnerWithDelay = createAction(
  '[Login] Schedule Spinner Display with Delay',
);

export const disableLoadingSpinner = createAction(
  '[Login] Disable Loading Spinner',
);

export const toggleLoadingSpinner = createAction(
  '[Login] Toggle Loading Spinner',
  props<{ isEnabled: boolean }>(),
);

export const addTokenText = createAction(
  '[Login] Add Token Text',
  props<{ tokenText: string }>(),
);

export const addStructIdLevel3 = createAction(
  '[Login] Add StructIdLevel3',
  props<{ structIdLevel3: string }>(),
);

export const resetPassword = createAction(
  '[ResetPassword] Start Reset Password',
  props<{ options: ResetPasswordOptions }>(),
);

export const resetPasswordSuccess = createAction(
  '[ResetPassword] Reset Password Success',
);

export const resetPasswordFailed = createAction(
  '[ResetPassword] Sign-in Failed',
  props<{ reason: ResetPasswordFailReason }>(),
);

export const preLoadProfile = createAction(
  '[Login] Pre Load Profile',
  props<{ ssoId: string }>(),
);

export const preLoadProfileSuccess = createAction(
  '[Login] Pre Load Profile Success',
);
export const clearSignInError = createAction('[Login] Clear Sign-in Error');
